import axios from 'axios';
import qs from 'qs';
import Cookie from 'js-cookie';
import { isObject } from '@/utils';
import { getToken } from '@/utils/auth';

const TOKEN_ERROR = -9999993;
function redirect(url) {
  if (window !== window.top) {
    window.top.location.href = url;
  } else {
    window.location.href = url;
  }
}

function getLoginPath(pathname) {
  if (pathname.startsWith('/pt')) {
    return '#/pt-login';
  }
  return 'login';
}

const service = axios.create({
  baseURL: '/',
  timeout: 30000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
// 请求拦截器
service.interceptors.request.use((config) => {
  if (!config.multi) {
    // eslint-disable-next-line no-param-reassign
    config.data = qs.stringify(config.data);
  }

  if (!config.baseURL.includes('check-video') && getToken()) {
    // eslint-disable-next-line no-param-reassign
    // config.headers.Token = getToken();
  }

  if (Cookie.get('CRM_TOKEN')) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = Cookie.get('CRM_TOKEN');
    // console.log(config.headers['yx_token'])
  }
  if (localStorage.getItem('loginToken')) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Token = localStorage.getItem('loginToken');
  }
  if (localStorage.getItem('jupiterToken')) {
    // eslint-disable-next-line no-param-reassign
    config.headers['Hci-Token'] = localStorage.getItem('jupiterToken');
  }

  return config;
}, (error) => {
  console.log(error);
  Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (!isObject(response.data)) {
      return Promise.reject(response.data);
    }
    if (response.data.code <= 0) {
      if (response.data.code === TOKEN_ERROR) {
        const url = `${window.location.protocol}//${window.location.host}/${getLoginPath(window.location.pathname)}`;
        redirect(url);
        localStorage.clear();
      }
      return Promise.reject(response.data);
    }
    return response.data;
  },
  (error) => Promise.reject(error),
);

export default service;
